// extracted by mini-css-extract-plugin
module.exports = {"home_about":"y7hU_Y","description":"cv0ooZ"};